import React, { FC, useState } from 'react';
import { Form, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ICategory } from '../../../../../interfaces';
import { Col, Row } from 'antd';
import { useSelect } from '@refinedev/antd';
import {
    Checkbox,
    FormItem,
    Select,
    SelectProps,
    Textarea,
} from 'components/ui';
import styles from './changesForm.module.scss';

interface ChangesFormProps {
    fieldKey: number;
    [key: string]: any;
}

export const ChangesForm: FC<ChangesFormProps> = ({ fieldKey }) => {
    const t = useTranslate();
    const [checkbox, setCheckbox] = useState<any>([]);

    const { selectProps: changesProps } = useSelect<ICategory>({
        resource: 'dictionary/changes',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    }) as {
        selectProps: SelectProps<ICategory>;
    };

    const handleSelect = (event: CheckboxChangeEvent) => {
        let target = event.target;
        let id = target.id!.split('_').at(-2);

        if (target.checked) {
            setCheckbox(id);
        } else {
            setCheckbox(undefined);
        }
    };

    return (
        <>
            <Form.List name={[fieldKey, 'changes']}>
                {(changes, { add, remove }, { errors, warnings }) => {
                    return (
                        <>
                            {changes?.map((change, index, array) => {
                                return (
                                    <Space
                                        align="baseline"
                                        className={styles.changesWrap}
                                        key={change.key}
                                    >
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <FormItem
                                                    {...change}
                                                    name={[
                                                        change.name,
                                                        'changeId',
                                                    ]}
                                                    //@ts-ignore
                                                    fieldKey={[
                                                        //@ts-ignore
                                                        change.fieldKey,
                                                        'changeId',
                                                    ]}
                                                    key={index}
                                                >
                                                    <Select
                                                        label={t(
                                                            'applications.fields.change'
                                                        )}
                                                        {...changesProps}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    {...change}
                                                    name={[
                                                        change.name,
                                                        'description',
                                                    ]}
                                                    //@ts-ignore
                                                    fieldKey={[
                                                        //@ts-ignore
                                                        change.fieldKey,
                                                        'description',
                                                    ]}
                                                    key={index}
                                                >
                                                    <Textarea
                                                        label={t(
                                                            'applications.fields.description'
                                                        )}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    {...change}
                                                    name={[
                                                        change.name,
                                                        'isMain',
                                                    ]}
                                                    //@ts-ignore
                                                    fieldKey={[
                                                        //@ts-ignore
                                                        change.fieldKey,
                                                        'isMain',
                                                    ]}
                                                    key={index}
                                                    valuePropName="checked"
                                                    hidden={
                                                        checkbox?.length
                                                            ? checkbox !==
                                                              change.name.toString()
                                                            : false
                                                    }
                                                >
                                                    <Checkbox
                                                        title={t(
                                                            'applications.fields.is_main'
                                                        )}
                                                        onChange={handleSelect}
                                                    />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <Row
                                                    justify="end"
                                                    gutter={[16, 16]}
                                                >
                                                    <Col>
                                                        <Button
                                                            type="text"
                                                            danger
                                                            icon={
                                                                <MinusCircleOutlined />
                                                            }
                                                            onClick={() => {
                                                                remove(
                                                                    change.name
                                                                );
                                                                if (
                                                                    checkbox ===
                                                                    change.name.toString()
                                                                ) {
                                                                    setCheckbox(
                                                                        undefined
                                                                    );
                                                                }
                                                            }}
                                                            aria-label={t(
                                                                'buttons.delete'
                                                            )}
                                                        >
                                                            {t(
                                                                'buttons.delete'
                                                            )}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Space>
                                );
                            })}
                            <Form.Item noStyle>
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        add();
                                    }}
                                >
                                    <PlusOutlined />{' '}
                                    {t('applications.fields.add_changes')}
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>
                    );
                }}
            </Form.List>
        </>
    );
};
